import React from "react";
import CreatableSelect from "react-select/creatable";
import MyLabel from "./MyLabel";

const MyCreateSelect = ({
  title,
  multi = true,
  name,
  placeholder,
  register,
  required = false,
  watch,
  errors,
  setValue,
  trigger,
  options = [],
  disabled = false,
}) => {
  const handleSelectChange = (selectedOption) => {
    // Convert selected option objects to plain values
    const values = selectedOption
      ? selectedOption.map((v) => (typeof v === "string" ? v : v.value))
      : [];
    setValue(name, values);
    trigger(name);
  };

  const value = (watch(name) || []).map((v) => ({ label: v, value: v }));

  return (
    <div className="form-group mt-2">
      <MyLabel name={name} title={title} required={required} />
      <div className="form-control-wrap">
        <CreatableSelect
          isMulti={multi}
          placeholder={placeholder}
          id={name}
          options={options}
          value={value}
          onChange={handleSelectChange}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              borderColor: errors?.[name] ? "red" : "grey",
            }),
          }}
          isDisabled={disabled}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyCreateSelect;